import React from 'react';
import { List } from '@mui/material';
import YouTubeCtaListItem from './YouTubeCta/YouTubeCtaListItem';
import ParticlesListItem from './Particles/ParticlesListItem';
import ImageElementsEditor from './ImageElements/ImageElementsEditor';
import { ELEMENTS_PANEL_TABS } from '../../CreatePageConstants';

// The panel is split in two: the pictures a user places on the video, and everything else. The tabs
// themselves belong to the section around this editor, which is where the store keeps the choice.
class VideoElementsEditor extends React.Component {
    render() {
        const { selectedTab } = this.props;

        if (selectedTab === ELEMENTS_PANEL_TABS.IMAGE_ELEMENTS || selectedTab === ELEMENTS_PANEL_TABS.IMAGES)
            return (
                <div id='elements-image-elements-panel' role='tabpanel' aria-labelledby='elements-image-elements-tab'>
                    <ImageElementsEditor />
                </div>
            );

        return (
            <div id='elements-other-panel' role='tabpanel' aria-labelledby='elements-other-tab'>
                <List
                    dense
                    disablePadding
                >
                    <YouTubeCtaListItem advanced={true} />
                    <ParticlesListItem advanced={true} />
                </List>
            </div>
        );
    }
}

export default VideoElementsEditor;
